import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { RespondWorflowChecklistItemsComponent } from '../respond-worflow-checklist-items/respond-worflow-checklist-items.component';

@Component({
  selector: 'app-document-previous-revision-checklist',
  templateUrl: './document-previous-revision-checklist.component.html',
  styleUrls: ['./document-previous-revision-checklist.component.css']
})
export class DocumentPreviousRevisionChecklistComponent implements OnInit {
  public gridView =[];
  public selectionAction : any[]=[];


  @ViewChild(DataBindingDirective) directive: any;
  @ViewChild('docgrid') docGrid: any;
  constructor(public dialogRef: MatDialogRef<DocumentPreviousRevisionChecklistComponent>,private dialog: MatDialog,@Inject(MAT_DIALOG_DATA) public data: any) 
  { 

  }

  ngOnInit() {   
    this.data.forEach((each: { [x: string]: string; },index: any) => {  
      each['itemIndex']= index,
      each['clFullName'] = each['cL_Short_Description'] + ' - ' + each['cL_Description']; 
    }); 
  this.gridView = this.data;  
  }


  closeDialog() {     
   this.dialogRef.close(this.selectionAction);
   //this.dialogRef.close();
  }

  postData() {
    this.closeDialog();
  }

  // public openChecklistItems(dataitem) {  
  //   debugger;        
  //   if(!!dataitem){ 
  //     let dataItem={
  //       "clId" : dataitem.cL_Id,
  //       "clFullName":dataitem.clFullName,
  //       "documentId":dataitem.doc_Id,
  //       "documentRevision": dataitem.revision_No,        
  //     }
  //     let dialogRef = this.dialog.open(RespondWorflowChecklistItemsComponent, {
  //         panelClass: 'mat-dialog-primary',
  //         data: {dataItem, 'isReadMode':false}  
  //     });
  //     dialogRef.afterClosed().subscribe((data) => {          
  //     });
  //   }   
  // }

  onSelectionChange(event: any): void {     
    if (event['selectedRows'].length > 0) {   
      event['selectedRows'].forEach((element: { dataItem: { isSelected: boolean; }; }) => {        
       element.dataItem.isSelected = true;
       this.selectionAction.push(element.dataItem);     
     });
  }
  if (event['deselectedRows'].length > 0) {
    event['deselectedRows'].forEach((element: { dataItem: { docId: any; revision: any; }; }) => {
        for(let i=0;i<this.selectionAction.length;i++){
          if (element.dataItem.docId == this.selectionAction[i].docId && element.dataItem.revision == this.selectionAction[i].revision){
            this.selectionAction.splice(i,1);
          }
        }
  });
 }
}

}
